import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function HotelStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M22.0002 21.25C22.4145 21.25 22.7502 21.5858 22.7502 22C22.7502 22.4142 22.4145 22.75 22.0002 22.75H2.00024C1.58603 22.75 1.25024 22.4142 1.25024 22C1.25024 21.5858 1.58603 21.25 2.00024 21.25H22.0002Z"
				fill="currentColor"
			/>
			<path
				d="M20.2501 11C20.2501 10.3096 19.6904 9.75 19.0001 9.75H13.0001C12.3097 9.75 11.7501 10.3096 11.7501 11V22H10.2501V11C10.2501 9.48122 11.4812 8.25 13.0001 8.25H19.0001C20.5189 8.25 21.7501 9.48122 21.7501 11V22H20.2501V11Z"
				fill="currentColor"
			/>
			<path
				d="M14.2501 4C14.2501 3.30964 13.6904 2.75 13.0001 2.75H5.00006C4.30971 2.75 3.75006 3.30964 3.75006 4V22H2.25006V4C2.25006 2.48122 3.48128 1.25 5.00006 1.25H13.0001C14.5189 1.25 15.7501 2.48122 15.7501 4V9H14.2501V4Z"
				fill="currentColor"
			/>
			<path
				d="M6.00006 13.25C6.41428 13.25 6.75006 13.5858 6.75006 14C6.75006 14.4142 6.41428 14.75 6.00006 14.75H3.00006C2.58585 14.75 2.25006 14.4142 2.25006 14C2.25006 13.5858 2.58585 13.25 3.00006 13.25H6.00006ZM6.00006 9.25C6.41428 9.25 6.75006 9.58579 6.75006 10C6.75006 10.4142 6.41428 10.75 6.00006 10.75H3.00006C2.58585 10.75 2.25006 10.4142 2.25006 10C2.25006 9.58579 2.58585 9.25 3.00006 9.25H6.00006ZM6.00006 5.25C6.41428 5.25 6.75006 5.58579 6.75006 6C6.75006 6.41421 6.41428 6.75 6.00006 6.75H3.00006C2.58585 6.75 2.25006 6.41421 2.25006 6C2.25006 5.58579 2.58585 5.25 3.00006 5.25H6.00006Z"
				fill="currentColor"
			/>
			<path
				d="M17.0003 15.25C17.4145 15.25 17.7503 15.5858 17.7503 16C17.7503 16.4142 17.4145 16.75 17.0003 16.75H15.0003C14.5861 16.75 14.2503 16.4142 14.2503 16C14.2503 15.5858 14.5861 15.25 15.0003 15.25H17.0003ZM17.0003 12.25C17.4145 12.25 17.7503 12.5858 17.7503 13C17.7503 13.4142 17.4145 13.75 17.0003 13.75H15.0003C14.5861 13.75 14.2503 13.4142 14.2503 13C14.2503 12.5858 14.5861 12.25 15.0003 12.25H17.0003Z"
				fill="currentColor"
			/>
			<path
				d="M15.2503 22V19C15.2503 18.5858 15.5861 18.25 16.0003 18.25C16.4145 18.25 16.7503 18.5858 16.7503 19V22C16.7503 22.4142 16.4145 22.75 16.0003 22.75C15.5861 22.75 15.2503 22.4142 15.2503 22Z"
				fill="currentColor"
			/>
		</svg>
	);
}

HotelStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default HotelStrokeIcon;
